import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import actionCreators from 'actionCreators';
import LocationPickerMapContainer from 'components/LocationPickerMapContainer';
import Notification from 'components/Notification';
import { acceptSiteUpdate } from 'ducks/userSettings';

const mapStateToProps = (state, ownProps) => ({
    ...state,
    ...ownProps,
    actionCreators
});
const mapDispatchToProps = (dispatch) => ({
    closeNotification: () => {
        dispatch(acceptSiteUpdate());
    }
});

const PageWrapper = ({className, showNotification = {}, children, closeNotification}) => {
    return (
        <div className={className}>
            {showNotification.visible && showNotification.isSemantic && (
                <Notification>
                    {showNotification.hasIcon && <Icon name={showNotification.icon || 'checkmark'}/>}
                    {showNotification.message ? showNotification.message : 'Template saved! We’ll remember this next time you make a report.'}
                </Notification>
            )}
            {showNotification.visible && !showNotification.isSemantic && (
                <Snackbar open
                          anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'center'
                          }}
                          TransitionComponent={Slide}
                >
                    <SnackbarContent
                        message={showNotification.message || 'Saved'}
                        sx={{
                            backgroundColor: (theme) => theme.palette.primary.main,
                            color: (theme) => theme.palette.primary.contrastText
                        }}
                        action={
                            <Button
                                sx={{
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                    color: (theme) => theme.palette.primary.contrastText
                                }}
                                variant="text"
                                size="small"
                                onClick={closeNotification}
                            >
                                UPDATE
                            </Button>
                        }
                    />
                </Snackbar>
            )}
            <LocationPickerMapContainer/>
            {children}
        </div>
    );
};

PageWrapper.propTypes = {
    className: PropTypes.string,
    closeNotification: PropTypes.func.isRequired,
    showNotification: PropTypes.shape({
        hasIcon: PropTypes.bool,
        icon: PropTypes.string,
        isSemantic: PropTypes.bool,
        message: PropTypes.string,
        visible: PropTypes.bool,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(PageWrapper);